/// <reference path="../../../../typings/index.d.ts" />

module Meevo.Plugins.MeevoMessenger {
    angular.module("meevo.plugins.meevoMessenger", []);
}
